import { Observable } from 'rxjs/Rx';


export abstract class BaseService {  
    
    constructor() { }

    protected handleError(error: any) {
    var applicationError = error.headers.get('Application-Error');

    // either applicationError in header or model error in body
    if (applicationError != null && applicationError ) {
      return Observable.throw(applicationError);
    }

    var modelStateErrors: string = '';
    var serverError = error.error;

    if (error != null && error.status == 400) {
      for (var key in serverError) {
        if (serverError[key])
          modelStateErrors += serverError[key] + '\n';
      }
    }

    modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;
    return Observable.throw(modelStateErrors || 'Server error');
  }
}
